import React from "react";
import { useSearchBoxCore, useSearchSession } from '@mapbox/search-js-react';

function useMapboxVerify() {
    const search = useSearchBoxCore({ accessToken: 'pk.eyJ1IjoiY2FwaXRhbGhlZGdlIiwiYSI6ImNqMWdmMm90ZDAwNHEycW8wcTA5ajV6NGkifQ.ePPX9y2Yz7rjSW87D1uoWw' })
    const session = useSearchSession(search);

    const verify = async (addressText) => {
        const response = await session.suggest(addressText);

        if (response.suggestions.length > 0) {
            const suggestion = response.suggestions[0];
            const {address, country, place, postcode, region} = suggestion.context
            const verificationData = {
                valid: Boolean(address),
                address: address?.name,
                country: country?.name,
                state: region?.name,
                city: place?.name,
                zipCode: postcode?.name,
            }
            return verificationData
        } else {
            return {
                valid: false,
            }
        }
    }

    return {
        verify
    }
}

export default useMapboxVerify;